import { combineReducers } from "redux";
import { userReducer } from "./userReducer";
import { productReducer } from "./productReducer";
import { reducer as toastrReducer } from "react-redux-toastr";
import { cartReducer } from "./cartReducer";
import { orderReducer } from './orderReducer';
import {categoriaReducer} from './categoriaReducer';

export default combineReducers({
    user: userReducer,
    categoria:categoriaReducer,
    product: productReducer,
    cart: cartReducer,
    order: orderReducer,
    toastr: toastrReducer,
});
